import { NheDetails } from "./application-data";
import { processTime } from "./time-processor";
import moment from "moment";
import "moment-timezone";

export function GetCalendarEvent(nheDetails: NheDetails | undefined, title?: string, location?: string): any {
  const timeFormat = "MMM DD, YYYY hh:mm A";
  const startTime = nheDetails?.nheTimeRange?.split("-")[0];
  const endTime = nheDetails?.nheTimeRange?.split("-")[1];

  const processedStartTime = processTime(startTime);
  const processedEndTime = processTime(endTime);

  const startDateAndStartTime = nheDetails?.nheDate?.toString() + " " + processedStartTime;
  const startDateAndEndTime = nheDetails?.nheDate?.toString() + " " + processedEndTime;
  const dateTzWithStartTime = moment.tz(startDateAndStartTime, timeFormat, nheDetails?.timezone ?? "");
  const dateTzWithEndTime = moment.tz(startDateAndEndTime, timeFormat, nheDetails?.timezone ?? "");
  if (moment.duration(dateTzWithEndTime.diff(dateTzWithStartTime)).asMinutes() < 0) {
    dateTzWithEndTime.add(1, "d");
  }

  return {
    startTime: dateTzWithStartTime.format(),
    endTime: dateTzWithEndTime.format(),
    ...(title && { title: title }),
    ...(location && { location: location }),
  };
}
